import { isUnit, type WriteOffListRow, type WriteOffStatus } from '@eombor/contracts';
import type { Transition } from 'framer-motion';
import { unitText } from '../../../shared/i18n/labels.js';

/**
 * Jadval va kartochka UCHUN UMUMIY narsalar — ikkalasi bir xil props oladi
 * va bir xil qiymatlarni bir xil yozadi.
 */
export interface WriteOffRowsViewProps {
  rows: readonly WriteOffListRow[];
  onOpen: (id: string) => void;
  /** `prefers-reduced-motion` — kirish animatsiyasi o'chadi. */
  reduceMotion: boolean;
}

export const qtyText = (qty: number): string =>
  (Math.round(qty * 1000) / 1000).toLocaleString('ru-RU');

export const unitOf = (row: Pick<WriteOffListRow, 'unit'>): string =>
  isUnit(row.unit) ? unitText(row.unit) : row.unit;

const pad = (value: number): string => String(value).padStart(2, '0');

/** «04.09.2026» va «14:20» — `WriteOffDetail` dagi yozuv bilan bir xil. */
export const dayOf = (iso: string): { date: string; time: string } => {
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return { date: iso, time: '' };
  return {
    date: `${pad(date.getDate())}.${pad(date.getMonth() + 1)}.${date.getFullYear()}`,
    time: `${pad(date.getHours())}:${pad(date.getMinutes())}`,
  };
};

/** Kartochka chetidagi holat chizig'i — badge rangi bilan bir xil. */
export const STATUS_STRIPE: Record<WriteOffStatus, string> = {
  PENDING: 'bg-warn',
  APPROVED: 'bg-success',
  REJECTED: 'bg-danger',
  CANCELLED: 'bg-[color-mix(in_oklab,var(--color-danger)_35%,var(--color-border-strong))]',
};

/** Stagger faqat birinchi 8 element uchun: uzun ro'yxat sekin «oqib» chiqmasin. */
const STAGGER_LIMIT = 8;

export const enterTransition = (index: number, reduceMotion: boolean): Transition =>
  reduceMotion
    ? { duration: 0 }
    : {
        duration: 0.22,
        ease: [0.16, 1, 0.3, 1],
        delay: index < STAGGER_LIMIT ? index * 0.035 : 0,
      };

export const enterFrom = (reduceMotion: boolean) =>
  reduceMotion ? { opacity: 1, y: 0 } : { opacity: 0, y: 8 };
